import UseAxios from '../../Api/http/http';
import { fetchUserInfo, fetchHiringDetails } from '../../Api/request/integration';

export const getEmployeeData = async (data) => {
  try {
    const response = await UseAxios(fetchUserInfo(data));

    return response?.data?.users?.data || [];
  } catch (error) {
    console.error('Error fetching employee data:', error);
    throw error;
  }
};

export const getHiringDetails = async (fromDate, toDate, emailId, mobile) => {
  try {
    const response = await UseAxios(
      fetchHiringDetails(fromDate, toDate, emailId, mobile),
    );
    return response?.data || [];
  } catch (error) {
    console.error('Error fetching hiring details:', error);
    throw error;
  }
};
